import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { getNewsItemById } from '../services/strapi';

function formatDate(isoString) {
  if (!isoString) return '';
  const d = new Date(isoString);
  return d.toLocaleDateString('da-DK', { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function NewsDetailPage() {
  const { id } = useParams();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    getNewsItemById(id)
      .then((res) => {
        const attrs = res?.data?.attributes;
        if (!attrs) {
          setNotFound(true);
        } else {
          setItem(attrs);
        }
        setLoading(false);
      })
      .catch(() => {
        setNotFound(true);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <div className="container">Indlæser...</div>;
  if (notFound || !item) {
    return (
      <div className="container">
        Nyheden blev ikke fundet. <Link to="/">Tilbage til forsiden</Link>
      </div>
    );
  }

  return (
    <section className="section">
      <div className="container">
        <Link to="/" style={{ display: 'block', marginBottom: '2rem' }}>← Tilbage til forsiden</Link>
        <div style={{ fontSize: '0.9rem', color: '#888', marginBottom: '0.5rem' }}>
          {formatDate(item.publishedAt)}
        </div>
        <h1 className="section__title" style={{ textAlign: 'left' }}>{item.title}</h1>
        <p style={{ whiteSpace: 'pre-line', marginTop: '1.5rem' }}>{item.content}</p>
        {item.url && (
          <a
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--link"
            style={{ display: 'inline-block', marginTop: '1.5rem' }}
          >
            Se originalt opslag på Facebook →
          </a>
        )}
      </div>
    </section>
  );
}
